// extracted by mini-css-extract-plugin
module.exports = {"jivo-chat-button":"jivoChatMobileAnimation_jivo-chat-button__lTiGp","jivo-chat-button--active":"jivoChatMobileAnimation_jivo-chat-button--active__s40qw"};